<template>
    <svg xmlns="http://www.w3.org/2000/svg" xml:space="preserve" :width="width" :height="height" version="1.1"
         style="shape-rendering:geometricPrecision; text-rendering:geometricPrecision; image-rendering:optimizeQuality; fill-rule:evenodd; clip-rule:evenodd"
         viewBox="0 0 54 89"
         xmlns:xlink="http://www.w3.org/1999/xlink">
     <g id="Слой_x0020_1">
      <metadata id="CorelCorpID_0Corel-Layer"></metadata>
         <path class="fill-black" :class="{'inter-active':selected}"
               d="M29 56c5,2 10,5 14,11 6,7 0,14 10,22 -13,-5 -9,-15 -14,-21 -8,-9 -19,-10 -24,0 -5,10 -6,17 -15,19 10,-10 8,-17 12,-24 1,-2 3,-4 5,-5m0 0c3,1 7,1 12,-2m-12 2c3,1 7,1 12,-2"></path>
         <path class="inter-fill inter-stroke" :class="{'inter-active':selected}" d="M42 11c2,-4 9,-5 10,-1 2,18 -4,40 -21,45 -25,14 -19,-20 -21,-36 5,-10 11,-19 18,-19 8,0 11,6 14,11zm0 0c1,1 0,1 1,5"></path>
     </g>
    </svg>
</template>

<script>
    import {implantMixin} from '@/mixins/implant.js'

    export default {
        mixins: [implantMixin]
    }
</script>

<style scoped>

</style>
